import useSWR from 'swr';

import { apiClient } from '@src/clients';
import { ReactComponent as BellIcon } from '@src/icons/bell.svg';
import { ReactComponent as CircleIcon } from '@src/icons/circle-filled.svg';

import styles from './styles.module.css';

interface NotificationIconProps {
  className?: string;
}

export default function NotificationIcon({
  className = ''
}: NotificationIconProps) {
  const { data } = useSWR(
    '/feed/unread_count',
    apiClient.beacon.apiUserSelfFeedUnreadCountList,
    { revalidateOnMount: true, refreshInterval: 1000 }
  );

  const unreadCount = data?.data?.count || 0;
  const hasUnreadMessages = unreadCount > 0;
  return (
    <div className={styles.sidebarIconWrapper}>
      {hasUnreadMessages ? (
        <CircleIcon className={styles.sidebarIconUnreadDot} />
      ) : null}
      <BellIcon className={className} />
    </div>
  );
}
